import ContactForm7 from './contact-form-7';

new ContactForm7();
